// extracted by mini-css-extract-plugin
export default {"container":"style_container__ob2aF","icon":"style_icon__NqtaD","itemContent":"style_itemContent__lg6ox","itemTitle":"style_itemTitle__LNbUd","itemText":"style_itemText__DuMbX"};